export default "__VITE_ASSET__mzclbjrQ__"